import React, { useEffect } from "react";
import api from "src/store/features/api";
import { setBirthdate } from "src/store/features/onboarding.slice";
import { useAppDispatch } from "src/store/store";

export default function useAutofillFromOnfido() {
  const { data: extractedData } = api.useExtractWorkflowDocPropQuery();
  const [foundDoB, setFoundDoB] = React.useState(false);
  const [foundPoA, setFoundPoA] = React.useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (extractedData?.date_of_birth) {
      const extractedDoB = extractedData?.date_of_birth;
      // change extracted DoB from DD-MM-YYYY to YYYY-MM-DD
      const reformatedDoB = extractedDoB.split("-").reverse().join("-");
      const extractedDocumentType = extractedData?.document_type;

      if (extractedDoB) {
        const [birthDay, birthMonth, birthYear] = reformatedDoB.split("-");
        setFoundDoB(!!extractedDoB);

        dispatch(
          setBirthdate({
            day: birthDay,
            month: birthMonth,
            year: birthYear,
          }),
        );
      }

      if (extractedDocumentType) {
        // Add types that are acceptable as a proof of address
        setFoundPoA(extractedDocumentType === "driving_licence");
      }
    }
  }, [extractedData]);

  return { foundDoB, foundPoA };
}
